import * as React from "react";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";

import { BillWurtzPage } from "./Pages/BillWurtzPage";
import { ErrorPage } from "./Pages/ErrorPage";
import { HomePage } from "./Pages/HomePage";
import { ImagePage } from "./Pages/ImagePage";
import { NewHomePage } from "./Pages/NewHomePage";
import { PoemPage } from "./Pages/PoemPage";

import "./App.css";

function App(): JSX.Element {
    return (
        <BrowserRouter>
            <Switch>
                <Route exact={true} path="/" component={HomePage} />
                <Route path="/images" component={ImagePage} />
                <Route path="/billwurtz" component={BillWurtzPage} />
                <Route path="/error" component={ErrorPage} />
                <Route path="/newhome" component={NewHomePage} />
                <Route path="/poems/:name?" component={PoemPage} />
                <Redirect to="/error" />
            </Switch>
        </BrowserRouter>
    );
}

export default App;
